import { useState, useEffect } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useSession } from "@clerk/clerk-react";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { API_URL } from "constants/index";
import MilestoneSection from "shared/components/rental/sections/milestone-section";
import { Spinner } from "@heroui/react";

const Milestones = () => {
  const { session } = useSession();
  const [milestones, setMilestones] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchMilestones = async () => {
    try {
      setIsLoading(true);
      const response = await fetchWithAuth(
        `${API_URL}/rental/milestones`,
        { method: "GET" },
        session
      );
      const data = await response.json();
      setMilestones(data);
    } catch (error) {
      console.error("Failed to fetch milestones:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (session) {
      fetchMilestones();
    }
  }, [session]);

  if (isLoading) {
    return (
      <div className="flex h-[400px] items-center justify-center bg-neutral-50">
        <Spinner
          size="lg"
          color="primary"
          label="Gebeurtenissen laden..."
          classNames={{
            wrapper: "flex flex-col items-center gap-4",
            circle1: "border-b-moss-primary",
            label: "text-moss-primary font-medium"
          }}
        />
      </div>
    );
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Belangrijke Gebeurtenissen | Yally</title>
        </Helmet>
      </HelmetProvider>

      <div className="space-y-4">
        <MilestoneSection
          incomingMilestones={milestones}
          onMilestoneUpdate={fetchMilestones}
        />
      </div>
    </>
  );
};

export default Milestones;
